/* eslint-disable no-console */
// Third-party libraries
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { intComma } from "humanize-plus";
import ReactTags from "react-tag-autocomplete";

// Project dependencies
import { LoadingBar } from "../components/widgets";
import { getHeaders, leagueUrl, playerUrl, errorHandler } from "../apihelpers";
import { Meta } from "../utilities";
import FileNotFound from "../pages/FileNotFound";
import LoanIcon from "../svg/LoanIcon";
import LoginForm from "../components/LoginForm";
import variables from "../styleVariables";
import WapIcon from "../svg/WapIcon";

class League extends Component {
  slug = this.props.match.params.slug;
  token = this.props.match.params.token;

  _tokenChecked = false;
  _isMounted = false;
  state = {
    loading: false, // For inviting new players
    notFound: false,
    joined_league: false,
    already_member: false,
    token_match: true,
    bad_token: false,
    show: "overall", // or  'cyclocorss','spring','giro','tour','vuelta', or 'worlds'
    allplayers: [], // list of potential invitees,
    invitees: [],
    already_invited: [], // list of ids for players already invited; use this to filter suggestions
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getLeague() {
    const headers = getHeaders();
    fetch(leagueUrl + "/" + this.slug + "?" + Date.now(), {
      method: "GET",
      headers,
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          if (data.error) {
            this.setState({ notFound: true });
          } else {
            this.setState(data, () => {
              if (
                this.props.player &&
                this.props.loggedIn &&
                this.token &&
                !this._tokenChecked
              ) {
                this.checkToken(this.slug, this.token);
              }
            });
          }
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          this.setState({ notFound: true });
        }
        console.log(error);
      });
  }

  checkToken(leagueSlug, token) {
    this._tokenChecked = true;
    if (this.state.joined_league || this.state.already_member) {
      return true;
    }
    const headers = getHeaders();
    fetch(leagueUrl + "/" + leagueSlug, {
      method: "POST",
      headers,
      body: JSON.stringify({ token: token }),
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          this.setState({
            token_match: data.token_match,
            joined_league: data.joined_league,
            already_member: data.already_member,
          });
          if (data.joined_league) {
            window.gtag("event", "accept invite", {
              event_category: "league",
              event_label: `${this.state.name}`,
            });
            this.getLeague();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getPlayers() {
    const headers = getHeaders();
    fetch(playerUrl, {
      method: "GET",
      headers,
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          this.setState({
            allplayers: data
              .filter(
                (player) =>
                  player.opted_out_of_league_invites === false &&
                  player.id !== this.props.player.id
              )
              .map((player) => ({ id: player.id, name: player.screen_name })),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleDelete(i) {
    const invitees = this.state.invitees.slice(0);
    const deleted = invitees.splice(i, 1);
    const allplayers = deleted.concat(this.state.allplayers);
    this.setState({ invitees: invitees, allplayers: allplayers });
  }

  handleAddition(invitee) {
    const invitees = [].concat(this.state.invitees, invitee);
    const allplayers = [].concat(
      this.state.allplayers.filter((player) => player.id !== invitee.id)
    ); // Remove invitee from list of suggestions
    this.setState({ invitees: invitees, allplayers: allplayers });
  }

  handleValidate(invitee) {
    return this.state.invitees.findIndex((i) => i.name === invitee.name) < 0;
  }

  handleSubmit(event) {
    this.setState({ loading: true });
    event.preventDefault();
    const headers = getHeaders();
    fetch(leagueUrl + "/invite", {
      method: "POST",
      headers,
      body: JSON.stringify({
        slug: this.slug,
        invitees: this.state.invitees,
      }),
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          if (data.error) {
            console.log(data);
          } else {
            window.gtag("event", "invite players", {
              event_category: "league",
              event_label: `${this.state.name}`,
            });
            this.setState({
              loading: false,
              players_invited: true,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getLeague();
    this.getPlayers();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    // Check to see if the player is newly logged in
    if (
      prevProps.loggedIn === false &&
      this.props.loggedIn === true &&
      this._tokenChecked === false
    ) {
      this.checkToken(this.slug, this.token);
    }
  }

  render() {
    if (this.state.notFound) {
      return <FileNotFound />;
    } else if (!this.state.name) {
      return <LoadingBar />;
    } else {
      return (
        <Fragment>
          <Meta
            title={`${this.state.name}`}
            description={`These are the current leaders in the ${this.state.name} league on Rouleur Derby.`}
          />

          <h1>{this.state.name}</h1>

          {this.props.player &&
            this.props.player.id === this.state.owner.id && (
              <div className="alert alert--primary-color">
                <p>
                  You are the owner of this league. To invite new players,
                  including friends who aren’t playing Rouleur Derby yet, share
                  this URL:{" "}
                  <strong>
                    <span className="user-select">
                      https://www.rouleurderby.com/league/{this.slug}/
                      {this.state.invite_token}
                    </span>
                    &nbsp;.
                  </strong>
                </p>
                <p>
                  Be careful with that link. Anyone who has it will be able to
                  join your league.
                </p>
                {this.state.loading && <LoadingBar />}

                {this.state.players_invited ? (
                  <p>
                    <strong>Awesome.</strong> Those players will receive an
                    email invitation. Once they accept they’ll show up in the
                    standings.
                  </p>
                ) : (
                  <Fragment>
                    <p>
                      You can also have Rouleur Derby send more invitations:
                    </p>

                    <form onSubmit={this.handleSubmit}>
                      <ReactTags
                        tags={this.state.invitees}
                        suggestions={this.state.allplayers.filter(
                          (player) =>
                            this.state.already_invited.includes(player.id) ===
                              false &&
                            this.state.players
                              .map((existingPlayer) => existingPlayer.id)
                              .includes(player.id) === false
                        )}
                        handleDelete={this.handleDelete.bind(this)}
                        handleAddition={this.handleAddition.bind(this)}
                        handleValidate={this.handleValidate.bind(this)}
                        placeholder="Add player to invite"
                        minQueryLength={1}
                      />
                      <button>Invite</button>
                    </form>
                  </Fragment>
                )}
              </div>
            )}

          {this.state.joined_league && this.props.loggedIn && (
            <div className="alert alert--primary-color">
              <p>Welcome to the {this.state.name} league. Good luck!</p>
            </div>
          )}

          {this.state.token_match === false && (
            <div className="alert alert--primary-color">
              <p>
                It looks like you’re trying to join this league, but you are not
                using a valid link. Check with the league’s owner to get the
                correct invitation link, or{" "}
                <a href="mailto:info@rouleurderby.com">contact Rouleur Derby</a>{" "}
                for help.
              </p>
            </div>
          )}

          {this.token && !this.props.loggedIn && (
            <Fragment>
              <div className="alert alert--primary-color">
                <p>
                  It looks like you’re trying to join this league, but you are
                  not logged in. Please log in first. (Don’t have an account?{" "}
                  <Link to="/rd/new">Create one here</Link> and then return to
                  this page.)
                </p>
                <LoginForm afterLogin={this.props.afterLogin} />
              </div>
            </Fragment>
          )}

          {this.state.welcome && (
            <p>
              <strong>A note from {this.state.owner.screen_name}:</strong>{" "}
              {this.state.welcome}
            </p>
          )}

          <p>
            Figures on league leaderboards reflect only bets that have been
            resolved.
          </p>
          <p>
            <WapIcon color={variables.colorWap} />
            Members of{" "}
            <a
              href="https://www.wideanglepodium.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Wide Angle Podium
            </a>
          </p>

          <nav className="tab-nav">
            <button
              className={`tab-nav__tab ${
                this.state.show === "overall" && "tab-nav__tab--active"
              }`}
              onClick={() => this.setState({ show: "overall" })}
            >
              Overall
            </button>

            {/* <button
              className={`tab-nav__tab ${
                this.state.show === "tour" && "tab-nav__tab--active"
              }`}
              onClick={() => this.setState({ show: "tour" })}
            >
              Tour de France
            </button> */}

            {/* <button
              className={`tab-nav__tab ${
                this.state.show === "spring" && "tab-nav__tab--active"
              }`}
              onClick={() => this.setState({ show: "spring" })}
            >
              Spring Classics
            </button> */}

            <button
              className={`tab-nav__tab ${
                this.state.show === "cyclocross" && "tab-nav__tab--active"
              }`}
              onClick={() => this.setState({ show: "cyclocross" })}
            >
              Cyclocross
            </button>
          </nav>

          {this.state.players && this.state.players.length > 0 && (
            <div className="sticky-table-outer">
              <table className="contest__table table--sticky table--rank">
                {this.state.show === "overall" ? (
                  <thead>
                    <tr>
                      <th>Player</th>
                      <th className="figure">Points</th>
                      <th className="figure">Current action</th>
                      <th className="figure">Wins</th>
                      <th className="figure">Win %</th>
                    </tr>
                  </thead>
                ) : (
                  <thead>
                    <tr>
                      <th>Player</th>
                      <th className="figure">Return on investment</th>
                      <th className="figure">Bets in this contest</th>
                      <th className="figure">Points bet in this contest</th>
                      <th className="figure">Profit in this contest </th>
                    </tr>
                  </thead>
                )}
                <tbody>
                  <Standings
                    show={this.state.show}
                    players={this.state.players}
                    visitor={this.props.player}
                  />
                </tbody>
              </table>
            </div>
          )}
        </Fragment>
      );
    }
  }
}

function Standings({ show, players, visitor }) {
  if (show === "overall") {
    // Mirroring the sorting done in leaders.js
    var prevPlayer = {};
    return players
      .map((player) => {
        if (player.win_tally === 0) {
          player.winpct = 0;
        } else {
          player.winpct =
            (player.win_tally * 100) / (player.bet_tally - player.current_bets);
        }
        return player;
      })
      .sort((a, b) => b.netpoints - a.netpoints)
      .map((player, i) => {
        if (i === 0) {
          player.rank = 1;
          prevPlayer = player;
          return player;
        } else if (player.netpoints === prevPlayer.netpoints) {
          player.rank = "-\u00A0";
          prevPlayer = player;
          return player;
        } else {
          player.rank = i + 1;
          prevPlayer = player;
          return player;
        }
      })
      .map((player, i) => (
        <tr
          key={`${i}${show}`}
          className={visitor.id === player.id ? "rank-row--self" : ""}
        >
          <td>
            <div className="rank-cell">
              <div className="rank-cell__rank">
                {typeof player.rank === "number"
                  ? `${player.rank}.`
                  : player.rank}
              </div>
              <div className="rank-cell__name">
                {player.podium_member && <WapIcon color={variables.colorWap} />}
                <Link to={`/${player.handle}`}>
                  {player.screen_name}{" "}
                  {player.loaned_points > 0 && (
                    <LoanIcon
                      color={
                        player.id && player.id === visitor.id
                          ? "#ffffff"
                          : variables.colorCancel
                      }
                    />
                  )}
                </Link>
              </div>
            </div>
          </td>
          <td className="figure">{intComma(player.netpoints)}</td>
          <td className="figure">{intComma(player.current_action)}</td>
          <td className="figure">{intComma(player.win_tally)}</td>
          <td className="figure">{intComma(player.winpct)}%</td>
        </tr>
      ));
  } else {
    // Prepare a table for the contest
    return players
      .sort((a, b) => b[show + "_roi"] - a[show + "_roi"])
      .map((player, i) => {
        if (i === 0) {
          player.rank = 1;
          prevPlayer = player;
          return player;
        } else if (player[show + "_roi"] === prevPlayer[show + "_roi"]) {
          player.rank = "-\u00A0";
          prevPlayer = player;
          return player;
        } else {
          player.rank = i + 1;
          prevPlayer = player;
          return player;
        }
      })
      .map((player, i) => (
        <tr
          key={`${i}${show}`}
          className={visitor.id === player.id ? "rank-row--self" : ""}
        >
          <td>
            <div className="rank-cell">
              <div className="rank-cell__rank">
                {typeof player.rank === "number"
                  ? `${player.rank}.`
                  : player.rank}
              </div>
              <div className="rank-cell__name">
                {player.podium_member && <WapIcon color={variables.colorWap} />}
                <Link to={`/${player.handle}`}>
                  {player.screen_name}{" "}
                  {player.loaned_points > 0 && (
                    <LoanIcon
                      color={
                        player.id && player.id === visitor.id
                          ? "#ffffff"
                          : variables.colorCancel
                      }
                    />
                  )}
                </Link>
              </div>
            </div>
          </td>
          <td className="figure">{intComma(player[show + "_roi"])}%</td>
          <td className="figure">
            {intComma(player[show + "_resolved_bets"])}
          </td>
          <td className="figure">
            {intComma(player[show + "_resolved_waged"])}
          </td>
          <td className="figure">
            {intComma(
              player[show + "_resolved_gross"] -
                player[show + "_resolved_waged"]
            )}
          </td>
        </tr>
      ));
  }
}

export default League;
